module.exports = __webpack_public_path__ + "static/media/coffino.d8994c5c.png";